import { _RectangleStarBase } from './rectangleStarBase'

export class _TriangleHeartDefault extends _RectangleStarBase {
  cssType: 'default' | 'small' = 'default'
  protected initPC(): this {
    this['--favorited-icon-width'] = '0.44rem'
    this['--favorited-icon-height'] = '0.27rem'
    this['--favorited-icon-font-size'] = '0.16rem'
    return this
  }
  protected initH5(): this {
    this['--favorited-icon-width'] = '0.63rem'
    this['--favorited-icon-height'] = '0.38rem'
    this['--favorited-icon-font-size'] = '0.19rem'
    return this
  }
}
